export default {
  columns: {
    version: 'Version',
    signed_at: 'Signed at',
    internal_note: 'Internal note',
    signature_provider: 'Signature provider',
    file: 'Document',
    actions: 'Actions',
  },
  labels: {
    version: 'v{{version}}',
    no_history: 'No signature history available yet',
    providers: {
      selfhosted: 'Self-hosted',
      yousign: 'Yousign',
    },
  },
  buttons: {
    preview: 'Preview',
    download: 'Download',
  },
};
